import React from 'react';
import {Skeleton} from 'antd';
import HStack from '../../../../../common/Layout/HStack';
import VStack from '../../../../../common/Layout/VStack';
import Box from '../../../../../common/Layout/Box';

const SKELETON_ROW_WIDTHS = ['90%', '70%', '80%', '60%'];

const ChooseHugToSwapSkeleton = () => (
    <VStack space={'2.6rem'} width={'100%'}>
        <HStack space={'0.75rem'}>
            <Skeleton.Input active style={{ width: '280px', borderRadius: '3px', height: '20px' }} />
            <Skeleton.Input active style={{ width: '280px', borderRadius: '3px', height: '20px' }} />
        </HStack>
        <VStack space={'1rem'} width={'100%'}>
            {SKELETON_ROW_WIDTHS.map((width, idx) => (
                <HStack key={idx} alignItems={'center'} space={'0.75rem'} style={{ width: '100%' }}>
                    <Skeleton.Avatar active size={'small'} shape={'circle'} />
                    <Box style={{ width, minWidth: 0, display: 'block' }}>
                        <Skeleton.Input active block style={{ borderRadius: '4px', height: '16px' }} />
                    </Box>
                </HStack>
            ))}
        </VStack>
    </VStack>
);

export default ChooseHugToSwapSkeleton;
